<template>
  <div
    v-tooltip="{
      content: tooltipContent,
      placement: 'bottom',
    }"
    class="bookmark-icon-wrap square-icon-wrap"
    @click.stop="bookmarkToggle"
  >
    <em
      :style="iconStyle"
      class="custom-icons page-toolbar"
    />
  </div>
</template>

<script>
import BookmarkMixin from '@/mixins/BookmarkMixin';
import customIconsMixin from '@/mixins/customIconsMixin';
import useGetBookmarkTooltipText from '@/utilities/composables/useGetBookmarkTooltipText';
import { ResourceType } from '@/types/resources';

export default {
  name: 'BookmarkedIcon',
  mixins: [customIconsMixin, BookmarkMixin],
  props: {
    entity: {
      type: Object,
      required: true,
      default: () => {},
    },
    entityName: {
      type: String,
      required: true,
      default: '',
    },
  },

  setup() {
    const { getTooltipText } = useGetBookmarkTooltipText();

    return {
      getTooltipText,
    };
  },

  computed: {
    bookmarked() {
      if (this.entityName === ResourceType.NoteTemplate) {
        return this.entity.is_favourited;
      }
      return this.isFavourite(this.entity.id, this.entityName);
    },

    tooltipContent() {
      return this.getTooltipText(
        this.bookmarked,
        this.entity.title,
        this.entityName,
        this.entity?.state
      );
    },

    iconStyle() {
      return {
        ...this.getCustomIconStyle(this.iconPath(this.bookmarked ? 'star-active' : 'star')),
        background: this.bookmarked ? '#FEC84B' : this.outlineColor,
      };
    },
    theme() {
      return this.$store.getters.getTheme;
    },

    outlineColor() {
      switch (this.theme) {
        case 'dark':
          return '#D0D5DD';
        case 'light':
          return '#475467';
        default:
          return '';
      }
    },

    archived() {
      return this.$route.name === 'archived';
    },
  },
  methods: {
    bookmarkToggle() {
      if (this.archived) return;
      this.toggleBookmark(this.entity, this.entityName);
    },
  },
};
</script>

<style lang="scss">
.bookmark-icon-wrap {
  @apply w-6 h-6 m-0;

  .page-toolbar {
    @apply w-4 h-4 m-0;
  }
}
</style>
